$(document).ready(function() {

	$('.accordion-parent').click(function(){
		$(this).toggleClass('active');
		$(this).nextAll('.accordion-child').toggleClass('active', $(this).hasClass('active'));
	});

	$('.nav3d__nav__item[data-post]').click(function(e){
		const button = $(e.currentTarget);
		const postId = button.data('post');
		const list = $('.nav3d__nav__'+postId);
		if(list.length > 0){
			e.preventDefault();
			const parent = button.parent();
			parent.one('webkitAnimationEnd oanimationend msAnimationEnd animationend',   
				function(e) {
					if(e.originalEvent.animationName === 'slide-out' && parent.hasClass('deactivate')){
						parent.removeClass('active').removeClass('deactivate');
						list.addClass('active');
					}
			});
			parent.addClass('deactivate');
		}
	});

	/**
	 * Instantiate Modals
	 */
	if( document.querySelector('.modal') ) {
		$('a[data-modal]').click(function(event) {
			$(this).modal({
				fadeDuration: 100
			});
			return false;
		});
		$('.touchevents .modal-trigger').bind('mouseover', function() {
			return false;
		});
	}

	/**
	 * Mobile Menu Toggle
	 */
	$('.nav-toggle').on('click', function(e) {
		e.preventDefault();
		$('html').toggleClass('show-menu');
	});

	/**
	 * Filter Block Toggle
	 */
	$('.filter-block-open').on('click', function(e) {
		e.preventDefault();
		$('html').addClass('show-filter-block');
	});
	$('.filter-block__close').on('click', function(e) {
		e.preventDefault();
		$('html').removeClass('show-filter-block');
	});

	/**
	 * Close open navs
	 */
	$('body').on('touchend', function(e) {

		// If not the language menu panel, close that panel
		var languageNavClasses = [
			'language-nav__panel language-nav__panel--visible', // open panel
			'language-nav__toggle' // panel toggle
		];
		if ( ! languageNavClasses.includes(e.target.className) ) {
			$('.language-nav__panel').removeClass('language-nav__panel--visible');
		}

		// If not a desktop nav submenu or link, close the panel
		var desktopNavClasses = [
			'sub-menu sub-menu--visible',
			'desktop-nav-link'
		]
		if ( ! desktopNavClasses.includes(e.target.className) ) {
			$('.desktop-nav .sub-menu').removeClass('sub-menu--visible');
		}
	});

	/**
	 * Language Nav Toggle
	 */
	$('.touchevents .language-nav__toggle').on('click', function(e) {
		e.preventDefault();
		$('.touchevents .language-nav__panel').toggleClass('language-nav__panel--visible');
	});

	/**
	 * Header Search Toggle
	 */
	$('.site-header__search input[type="submit"]').on('click', function(e) {
		e.preventDefault();

		if ( $('.site-header__search').hasClass('site-header__search--open') && $('.site-header__search .sf-input-text').val() !== '' ) {
			$('.site-header__search form').submit();
		} else {
			$('.site-header__search').toggleClass('site-header__search--open');
		}
	});

	/**
	 * Header Nav Toggle
	 */
	$('.touchevents .desktop-nav .menu > li.menu-item-has-children > a').on('click', function(e) {
		e.preventDefault();
		if ( ! $(this).next('.sub-menu').hasClass('sub-menu--visible') ) {
			$('.sub-menu').removeClass('sub-menu--visible');
			$(this).next('.sub-menu').addClass('sub-menu--visible').focus();
		} else {
			window.location.href = $(this).attr('href');
		}
	});

	/**
	 * Mobile Nav Sub-menu Toggle
	 */
	$('.mobile-nav-panel .sub-menu-toggle').on('click', function(e) {
		if ( $(this).next('.sub-menu').hasClass('sub-menu--expanded') ) {
			$(this).next('.sub-menu').removeClass('sub-menu--expanded');
			$(this).html('<i class="fa fa-plus"></i>');
		} else {
			$('.mobile-nav-panel .sub-menu-toggle').html('<i class="fa fa-plus"></i>');
			$('.mobile-nav-panel .sub-menu').removeClass('sub-menu--expanded');
			$(this).next('.sub-menu').addClass('sub-menu--expanded');
			$(this).html('<i class="fa fa-minus"></i>');
		}
	});

	/**
	 * Mobile Panel Language Nav Toggle
	 */
	$('.mobile-nav-panel__language-nav-toggle').on('click', function() {
		$(this).toggleClass('mobile-nav-panel__language-nav-toggle--active');
		$('.mobile-nav-panel__language-nav-panel').toggleClass('mobile-nav-panel__language-nav-panel--expanded');
	});

	/**
	 * Resource Language Selector Toggle
	 */
	$('.touchevents .resource-language-selector__toggle').on('click', function() {
		$(this).toggleClass('resource-language-selector__toggle--active');
		$(this).next('.resource-language-selector__panel').toggleClass('resource-language-selector__panel--active');
	});

});

(function() {
	// Hide form labels if empty
	var formLabels = document.querySelectorAll('.gfield_label');
	var requiredString = '<span class="gfield_required">*</span>';
	if ( formLabels.length > 0 ) {
		for ( var i = 0; i < formLabels.length; i++ ) {
			if ( formLabels[i].innerHTML == requiredString ) {
				formLabels[i].style.display = "none";
			}
		}
	}
})();

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

/**
 * Set Height of thumbnail containers
 */
var resizeThumbnailContainer = debounce(function() {
	$('.thumbnail-container').each(function() {
		$(this).height( $(this).width() * 0.63 );
	})
});
resizeThumbnailContainer();
window.addEventListener('resize', resizeThumbnailContainer);
